import { gql } from '@apollo/client'

interface IPrepSettingsNodeType {
  id: number
  name: string
  type: string
  startDate: string
  endDate: string
  value: number
  deletedAt: string
  locationGroupId: number | null
  locationId: number | null
}

export interface IPrepSettingsType {
  prepSettings: {
    nodes: IPrepSettingsNodeType[]
  }
}

export const getPrepSettings = gql`
  query GetPrepSettings {
    prepSettings {
      nodes {
        id
        name
        type
        startDate
        endDate
        value
        deletedAt
        locationGroupId
        locationId
      }
    }
  }
`

export interface IScopeOption {
  locationGroupId: number
  scopeName: string
  scopeType: string
  storeCount: number
}

export interface IPrepSettingScopesType {
  listPrepSettingScopes: {
    nodes: IScopeOption[]
  }
}

export const listPrepSettingScopes = gql`
  query ListPrepSettingScopes {
    listPrepSettingScopes {
      nodes {
        locationGroupId
        scopeName
        scopeType
        storeCount
      }
    }
  }
`

// why: an exception carries the same shape as the value it hangs under, so one
// row type covers the all-locations value and every scoped override of it.
export interface IPrepSettingValueInput {
  value: number
  locationGroupId?: number | null
  locationId?: number | null
}

export interface IEditPrepSettingsDefaultVariables {
  iName: string
  iValues: IPrepSettingValueInput[]
}

export interface IEditPrepSettingsDefaultData {
  editPrepSettingsDefault: { clientMutationId: string | null } | null
}

export const editPrepSettingsDefault = gql`
  mutation EditPrepSettingsDefault($iName: String!, $iValues: JSON!) {
    editPrepSettingsDefault(input: { iName: $iName, iValues: $iValues }) {
      clientMutationId
    }
  }
`

export interface IScheduleInput extends IPrepSettingValueInput {
  startDate: string
  endDate: string
}

export interface IEditPrepSettingsScheduleVariables {
  iName: string
  iSchedules: IScheduleInput[]
}

export interface IEditPrepSettingsScheduleData {
  editPrepSettingsSchedule: { clientMutationId: string | null } | null
}

export const editPrepSettingsSchedule = gql`
  mutation EditPrepSettingsSchedule($iName: String!, $iSchedules: JSON!) {
    editPrepSettingsSchedule(
      input: { iName: $iName, iSchedules: $iSchedules }
    ) {
      clientMutationId
    }
  }
`
